import { TranslateLike } from './helper';
import { getEnumValueLabel } from './helper';

const SUBSCRIPTION_BILLING_CYCLE_KEY_MAP: Record<number, string> = {
  0: 'domain.subscription.billingCycle.notChange',
  1: 'domain.subscription.billingCycle.monthly',
  3: 'domain.subscription.billingCycle.quarterly',
  6: 'domain.subscription.billingCycle.sixMonths',
  12: 'domain.subscription.billingCycle.annual',
};

export const getSubscriptionBillingCycleLabel = (t: TranslateLike, durationNum?: number) => {
  // 目录年付档位含赠送月（如 12+1=13 个月服务时长），≥12 一律按年付展示
  // （口径对齐 perseus subscription-pricing：年付判定 durationNum >= 12）
  const normalized =
    durationNum !== null && durationNum !== undefined && durationNum >= 12 ? 12 : durationNum;
  return getEnumValueLabel(t, normalized as Pay.DurationNum, SUBSCRIPTION_BILLING_CYCLE_KEY_MAP);
};
